import { ComponentType } from '@angular/cdk/portal';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { fadeIn } from '@animations/fade-in';
import { DataItem } from '../../models/data-item';

@Component({
  selector: 'app-data-box',
  templateUrl: './data-box.component.html',
  styleUrls: ['./data-box.component.scss'],
  standalone: false,
  animations: [fadeIn],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataBoxComponent {
  @Input() iconName?: string;
  @Input() headerTitle?: string;
  @Input() dataItems?: DataItem[] | null;
  @Input() isLoading?: boolean | null;
  @Input() helpComponent?: ComponentType<unknown>;
  @Input() topBorderOnly = false;

  constructor(private dialog: MatDialog) {}

  onHelpClicked(): void {
    if (this.helpComponent) {
      this.dialog.open(this.helpComponent, {
        maxWidth: '95vw',
        maxHeight: '80vh',
      });
    }
  }
}
